//represents a playlist
var angular = require('angular');
module.exports.Playlist = ['config', '$resource', function Playlist(config, $resource) {
    return $resource(config.apiUri + '/playlists/:id/:method', {
        id: '@id',
        method: '@method'
    }, {
        query: {
            method: 'GET',
            isArray: true
        },
        copy: {
            method: 'POST',
            params: {
                method: 'copy'
            }
        },
        sort: {
            method: 'POST',
            params: {
                method: 'sort'
            }
        }
    });
}];

//helper to load a playlist
module.exports.PlaylistLoader = ['Playlist', '$q', function PlaylistLoader(Playlist, $q) {
    return function(params) {
        var delay = $q.defer();

        Playlist.get(params, function(response) {
            delay.resolve(response);
        }, function(response) {
            delay.reject('Unable to fetch Playlists');
        });

        return delay.promise;
    };
}];

module.exports.PlaylistItems = ['growl', 'config', '$resource', function PlaylistItems(growl, config, $resource) {

    var getIds = function(subjects) {
        var ids = [];

        angular.forEach(subjects, function(subject) {
            if (ids.indexOf(subject.id) === -1) {
                ids.push(subject.id);
            }
        });

        return ids;
    };

    return $resource(config.apiUri + '/playlists/:playlistId/contents/:method',
        {playlistId  : '@playlistId'},
        {
            query: {
                  method: 'GET',
                  isArray: true
            },
            save: {
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson({
                        playlist: data.playlistId,
                        subjects: data.subjects.map(function (subject) {
                            return subject.id;
                        })
                    });
                }
            },
            reorder: {
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson({
                        subjects: getIds(data.subjects)
                    });
                },
                params: {
                    method: 'reorder'
                },
                interceptor: {
                    responseError: function (data) {
                        growl.error('Sorry, you cannot make changes as you do not have edit permissions for this playlist');
                    }
                }
            },
            remove: {
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson({
                        subjects: data.subjects.map(function (subject) {
                            return subject.id;
                        })
                    });
                },
                params: {
                    method: 'remove'
                }
            }
    });
}];

//helper to load the contents of a playlist
module.exports.PlaylistItemsLoader = ['PlaylistItems', 'LoaderFactory', function PlaylistItemsLoader(PlaylistItems, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(PlaylistItems, params);
    };
}];

//loader for personal playlists
module.exports.PlaylistsLoader = ['Playlist', 'LoaderFactory', function PlaylistsLoader(Playlist, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(Playlist, params);
    };
}];

//who my playlist has been shared with
module.exports.MyPlaylistShare = ['config', '$resource', function MyPlaylistShare(config, $resource) {
    return $resource(config.apiUri + '/playlists/:playlistId/shares/:id', {
        playlistId: '@playlist.id',
        id: '@id'
    });
}];


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/services/Playlist.js